/* eslint-disable react-hooks/exhaustive-deps */
import './style.css';
import React, { useEffect } from 'react';
import anime from 'animejs';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import couvertureImg from '../../images/project.jpg'
import Footer from '../../Components/Footer';
import ScrollToTop from '../../Components/scrollup'
export default function Projets() {
  useEffect(() => {
    anime({
      targets: ".projectCard",
      translateX: [400, 0],
      opacity: [0, 1],
      scale: [0, 1],
      delay: anime.stagger(200, { start: 300 }),
      easing: "easeInOutQuad",
    });

  }, []);

  useEffect(() => {
    const elements = document.querySelectorAll(".projectCard:not(.vide)");
    anime({
      targets: elements,
      translateX: [400, 0],
      opacity: [0, 1],
      scale: [0, 1],
      delay: anime.stagger(300, { start: 400 }),
      easing: "easeInOutQuad",
    });
  }, []);


  return (
      <div className='projets'>
        <ScrollToTop/>
        <img src={couvertureImg} alt="couverture" className='couvertureImg' />
        <div className='nosProjets'>
        <h2>Nos Réalisations</h2>
        <p>Notre mission est de vous révéler, vous différencier et vous sublimer à travers des projets digitaux efficaces, uniques et avant-gardistes.
        Industrie, tech, sport, automobile, santé, restauration, mode, services, e-commerce... Découvrez quelques-unes de nos références.</p>
        <div className='refGrid'>
          {itemData.map((item,index) => (
             <Card  key={index} className='projectCard' sx={{
              width: { lg: "20vw", md: "35vw", sm: "32vw", xs: "45vw" },}} elevation={3}>
      <img
        className='projetsPic'
        src={require(`../../images/${item.img}.jpg`)}
        title={`${item.name}`}
        alt={`${item.name}`}
      />
      <CardContent sx={{height:180,marginTop:'-20px'}}>
        <h5 className='projetCardTitle' style={{color:`${item.color}`}}>
          {item.name}
        </h5>
        <p className='projetCardParagraph'>
         {item.descreption}
        </p>
      </CardContent>
      <CardActions sx={{marginTop:'-20px'}}>
       <a href={item.link} > <Button sx={{ fontSize:{lg:'12px',md:'12px',sm:'10px',xs:'10px'} }} endIcon={<OpenInNewIcon/>} size="small" style={{color:`${item.color}`,fontFamily:'Poppins'}}>visiter maintenant</Button></a>
      </CardActions>
    </Card>
          ))}
        </div>
        </div>
        <Footer/>
      </div>
    
    
  );
}

const itemData = [
  {
    img: "site1",
    name: "ebuy tunisie",
    descreption:'website ecommerce ! la destination en ligne pour tous vos besoins !',
    link:"https://www.ebuytn.com",
    color:'#F99984'
  },
  {
    img: "site2",
    name: "saveurs de fatma",
    descreption:"website ecommerce! Saveurs de Fatma est l'incarnation d'une gastronomie raffinée et l'essence d'un héritage transmis avec passion !",
    link:'https://www.saveursdefatma.com',
    color:'#859e96'
  },
  {
    img: "site3",
    name: "sanitek",
    descreption:"website sur mesure! Excellence en services sanitaires depuis 2011!",
    link:'https://www.sanitek.tn',
    color:'#008DBD'
  },
  {
    img: "site4",
    name: "MOOZAK'S French Tacos",
    descreption:"website sur mesure! These tacos lyonnais are a blend of Mexican and French flavors that anyone can enjoy",
    link:'https://www.moozak.co.uk',
    color:'#002594a8'
  },
  {
    img: "site5",
    name: "Blainville taxi",
    descreption:"website sur mesure! Votre partenaire de confiance pour tous vos déplacements en toute sécurité et confort!",
    link:'https://www.blainville.taxi',
    color:'#02539F'
  },
  {
    img: "site6",
    name: "Mascotte café-resto",
    descreption:"website sur mesure! Découvrez nos créations culinaires, préparées avec amour pour vous offrir un moment gastronomique exceptionnel!",
    link:'https://mascotte-sfax.web.app/',
    color:'#fbcf0f'
  },
  {
    img: "site7",
    name: "Industrie Moderne en Alliage",
    descreption:"website sur mesure! Bienvenue chez Industrie Moderne en Alliage",
    link:'https://ima-portes.vercel.app/',
    color:'#FCCD33'
  },
];
